import { EmissionStatus } from '../../api';


export const STATUSES_ORDER = [
    EmissionStatus.upcoming,
    EmissionStatus.acception,
    EmissionStatus.processing,
    EmissionStatus.active,
    EmissionStatus.closed,
];
